import "./setup";

const initGame = () => {
  const gameState: number[] = [];

  const questionWrapper = document.getElementById("question-wrapper");
  const indicator = document.getElementById("indicator");
  const results = document.getElementById("results");
  const successText = Array.from(document.getElementsByClassName("success-text")) as HTMLDivElement[];
  const failText = Array.from(document.getElementsByClassName("fail-text")) as HTMLDivElement[];
  const resultsBackButton = document.getElementById("results-back");
  if (!questionWrapper || !indicator || !results || !successText || !failText || !resultsBackButton) return;

  const questions: HTMLDivElement[] = Array.from(questionWrapper.querySelectorAll(".question"));
  if (questions.length === 0) return;

  const animateTo = (index: number) => {
    const distance = 100 * index;

    for (const question of questions) {
      question.style.transform = `translateX(-${distance}%)`;
    }
    results.style.transform = `translateX(-${distance}%)`;

    if (gameState.length < questions.length) {
      indicator.style.transform = `translateX(${distance}%)`;

      setTimeout(() => {
        for (const text of successText) text.style.display = "none";
        for (const text of failText) text.style.display = "none";
      }, 500);
    } else {
      indicator.style.transform = `translateX(0%) scaleX(${100 * questions.length}%)`;

      const totalPoints = gameState.reduce((a, b) => a + b, 0);
      if (totalPoints >= 2) {
        for (const text of successText) text.style.display = "block";
      } else {
        for (const text of failText) text.style.display = "block";
      }
    }
  };

  const addAnswer = (index: number, points: number) => {
    if (gameState[index]) return;

    gameState[index] = points;

    animateTo(index + 1);
  };

  const removeAnswer = (index: number) => {
    gameState.splice(index - 1);

    animateTo(index - 1);
  };

  for (const [index, question] of questions.entries()) {
    const buttons = Array.from(question.querySelectorAll("button.answer")) as HTMLButtonElement[];
    if (buttons.length === 0) return;

    for (const button of buttons) {
      button.addEventListener("click", (e) => {
        if (gameState.length > index) return;

        const points = Number(button.dataset.points);
        if (isNaN(points)) return;

        addAnswer(index, points);
      });
    }

    const backButton = question.querySelector("button.back") as HTMLButtonElement;

    if (!backButton) continue;

    backButton.addEventListener("click", (e) => {
      removeAnswer(index);
    });
  }

  resultsBackButton.addEventListener("click", (e) => {
    removeAnswer(questions.length);
  });
};

initGame();

const toQuickCheckButton = document.getElementById("to-quick-check");
const hero = document.getElementById("hero");

// tell parent to scroll to quick check
toQuickCheckButton?.addEventListener("click", () => {
  if (!hero) return;

  const heroStyles = window.getComputedStyle(hero);
  const height = hero?.clientHeight + parseInt(heroStyles.marginBottom) || 0;
  
  window.parent.postMessage(`quick-check-scroll:${height}`, "*");
});

const toConsultationButton = document.getElementById("to-consultation");

toConsultationButton?.addEventListener("click", (e) => {
  window.parent.postMessage("sc23:button-clicked:Zur-Beratung", "*");
});
